var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('a',{attrs:{"href":_vm.fileUrl,"target":_vm.target}},[_c('canvas',{attrs:{"id":_vm._uid}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }